import NavTabs from './src/NavTabs';
import './index.scss';

export default NavTabs;
